import styled from 'styled-components'
import BankIDLogotype from '../../assets/bankid_vector_rgb.svg'

export const Wrapper = styled.article`
  padding: ${({ theme }) => theme.gutterMedium};
  display: flex;
  flex-direction: column;
`

export const Text = styled.strong`
  color: ${({ theme }) => theme.themeColorPrimaryDarkend};
`
export const Logotype = styled(BankIDLogotype)`
  width: 75px;
  margin: 0 auto ${({ theme }) => theme.gutterMedium} auto;
`
